import type { v1 } from '@hc-frontend/services-lead-storage';
import { assoc, reduce } from 'ramda';

export function journeyAttributesMapper(
  journeyAttributes: v1.JourneyAttribute[],
) {
  const journeyAttributesMap: Partial<{
    [key in v1.JourneyAttributeCatalogKey]: v1.JourneyAttributeCatalog[key];
  }> = {
    ...reduce(
      (acc, curr) => assoc(curr.name, curr.value, acc),
      {},
      journeyAttributes,
    ),
  };
  return journeyAttributesMap;
}
